import { render, staticRenderFns } from "./GoodItem.vue?vue&type=template&id=1e5b55d8&scoped=true"
import script from "./GoodItem.vue?vue&type=script&lang=js"
export * from "./GoodItem.vue?vue&type=script&lang=js"
import style0 from "./GoodItem.vue?vue&type=style&index=0&id=1e5b55d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5b55d8",
  null
  
)

export default component.exports